

export function moveTitle(){
    $ = jQuery.noConflict();
    $(".title-archive").detach().prependTo("main.content.av-content-small");
}


// WEBPACK FOOTER //
// ./assets/ts/src/helpers/titleArchive.ts